/*
 * @Author: Dom
 * @Date: 2022-07-02 18:43:16
 * @LastEditTime: 2022-07-02 18:47:55
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\utils\downloadurl.ts
 */
const fileUrl =  {
    filedownurl: '/seller/v1/file/down'
}

export default fileUrl
